import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AudioControls from "../audio/SimpleAudioController";
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class NarratorSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.dialog),
            dialogAudio: props.dialogAudio,
            screenObject: props.screenObject,
            allowAudioAutoPlay: true,
            showLabels: false,
            showAnimation: false,
        };

        this.showResponse = this.showResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onComplete = this.onComplete.bind(this);

        //Create Refs
        this.speachBubble = React.createRef();
    }

    componentDidMount() {
        this.showResponse();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.dialog)
            });
        }
    }

    showResponse() {
        let objectRef = this.speachBubble.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SPEECH_BUBBLE_DURATION,
            delay: this.props.delay,
            callback: this.onComplete
        };
        animationHelper.showHeight(params);
    }

    onComplete() {
        this.handleProgression();
    }

    handleProgression() {
        this.props.callbacks.onObjectComplete(this.props.index);
    }

    render() {
        return (
            <div className="a-c" ref={this.speachBubble}>
                <div className="object-container-conversation narrator-text" ref={`narratorSpeak_${this.props.index}`}>
                    <div className="dialog-content">

                        {
                            appHelper.isDefined(this.state.screenObject) && appHelper.isDefined(this.state.screenObject.audio) && this.state.screenObject.audio.show_audio_controls && appHelper.isDefined(this.state.dialogAudio) && appHelper.isDefined(this.state.dialogAudio.id)
                                ?

                                <AudioControls audio={this.state.dialogAudio}
                                               autoPlay={this.state.allowAudioAutoPlay}
                                               themeType="dark"
                                               showLabels={this.state.showLabels}
                                               showAnimation={this.state.showAnimation}
                                               audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.dialogAudio.id}_${this.state.dialogAudio.type}`}/>

                                :
                                null
                        }
                        <div dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                    </div>
                </div>
            </div>
        );
    }
}

NarratorSpeak.propTypes = {
    asset_id: PropTypes.number.isRequired,
    option_id: PropTypes.number,
    index: PropTypes.number.isRequired,
    dialog: PropTypes.object.isRequired,
    delay: PropTypes.number.isRequired,
    callbacks: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    screenObject: PropTypes.object,
    dialogAudio: PropTypes.object,
    actions: PropTypes.object
};

NarratorSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NarratorSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/NarratorSpeak.js
 **/